/**
 * Transforma la lista cruda de transportistas (objetos con CODIGO/NOMBRE, tal
 * como los expone useRangos desde DeliveryService.getTransports(), sin
 * mapear) al formato { value, label } que necesitan los consumidores de
 * presentación: valueOptions de la columna singleSelect del DataGrid
 * (helpers/columns.js) y las opciones del <Select> del formulario de rangos
 * (RangoForm, TASK-008). Se centraliza aquí para que ambos consumidores
 * construyan la etiqueta de la misma forma y no diverjan si cambia la
 * convención (p. ej. pasar a "NOMBRE (CODIGO)").
 *
 * Formato de label conservado del legado (src/views/Rangos.js,
 * componentDidMount): `option.CODIGO + '-' + option.NOMBRE`.
 *
 * @param {Array<{CODIGO: string, NOMBRE: string}>} transportistas - Transportistas tal como los devuelve DeliveryService.getTransports()
 * @returns {Array<{value: string, label: string}>} Opciones listas para valueOptions/MenuItem
 */
export const mapTransportistasAOpciones = (transportistas = []) =>
    transportistas.map((transportista) => ({
        value: transportista.CODIGO,
        label: `${transportista.CODIGO}-${transportista.NOMBRE}`,
    }));
